/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Logout_From_ApplicationInputs */



/**
* | output |
* | --- |
* | "Logout from application" |
*
* @param {Logout_From_ApplicationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const logout_from_application = /** @type {((inputs?: Logout_From_ApplicationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Logout_From_ApplicationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Se déconnecter de l'application")
	if (locale === "de") return /** @type {LocalizedString} */ ("Von der Anwendung abmelden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Disconnettersi dall'applicazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выйти из приложения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar sesión en la aplicación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从应用程序注销")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アプリケーションからログアウト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एप्लिकेशन से लॉगआउट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sair do aplicativo")
	return /** @type {LocalizedString} */ ("Logout from application")
});